"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.districtPickerViewModel = districtPickerViewModel;
const published_1 = require("./published");
function calculatorsByDistrict(group) {
    const byDistrict = new Map();
    for (const item of group.calculators) {
        if (!item.district)
            continue;
        const items = byDistrict.get(item.district.key) ?? [];
        items.push(item);
        byDistrict.set(item.district.key, items);
    }
    return byDistrict;
}
function ancestorsOf(district, byKey) {
    const ancestors = [];
    const seen = new Set([district.key]);
    let parent = district.parent === undefined ? undefined : byKey.get(district.parent);
    while (parent && !seen.has(parent.key)) {
        ancestors.push(parent);
        seen.add(parent.key);
        parent = parent.parent === undefined ? undefined : byKey.get(parent.parent);
    }
    return parent ? [] : ancestors;
}
function indexDistricts(election, group) {
    const byKey = new Map();
    for (const district of election.districts ?? []) {
        if (!byKey.has(district.key))
            byKey.set(district.key, district);
    }
    const parentOf = new Map();
    const childrenOf = new Map();
    for (const district of byKey.values()) {
        const parent = ancestorsOf(district, byKey)[0];
        if (!parent)
            continue;
        parentOf.set(district.key, parent);
        const siblings = childrenOf.get(parent.key) ?? [];
        siblings.push(district);
        childrenOf.set(parent.key, siblings);
    }
    return { byKey, parentOf, childrenOf, calculatorsOf: calculatorsByDistrict(group) };
}
function isSection(district, index) {
    if (index.calculatorsOf.has(district.key) || (index.childrenOf.get(district.key)?.length ?? 0) === 0)
        return false;
    const parent = index.parentOf.get(district.key);
    return parent === undefined || isSection(parent, index);
}
function isTopLevel(district, index) {
    return !index.parentOf.has(district.key);
}
function hasCalculatorsBelow(district, index) {
    return index.calculatorsOf.has(district.key) || (index.childrenOf.get(district.key) ?? []).some((child) => hasCalculatorsBelow(child, index));
}
function districtRow(district, index, input) {
    const published = (index.calculatorsOf.get(district.key) ?? []).filter((item) => (0, published_1.isPublished)(input.calculators[item.key], input.now));
    const inside = index.childrenOf.get(district.key) ?? [];
    const children = inside.filter((child) => hasCalculatorsBelow(child, index)).map((child) => districtRow(child, index, input));
    const aliases = inside.filter((child) => !hasCalculatorsBelow(child, index)).map((child) => child.title);
    const href = published.length > 0 ? input.buildHref(district.key) : undefined;
    return {
        key: district.key,
        title: district.title,
        shortTitle: district.shortTitle,
        code: district.code,
        href,
        children: children.length > 0 ? children : undefined,
        aliases: aliases.length > 0 ? aliases : undefined,
    };
}
function districtPickerViewModel(input) {
    const { group, election } = input;
    const index = indexDistricts(election, group);
    const districts = [...index.byKey.values()];
    const { selection } = group;
    const sections = [];
    const topLevelRows = districts.filter((district) => !isSection(district, index) && isTopLevel(district, index)).map((district) => districtRow(district, index, input));
    if (topLevelRows.length > 0) {
        sections.push({ key: "", rows: topLevelRows });
    }
    for (const section of districts.filter((district) => isSection(district, index))) {
        const rows = (index.childrenOf.get(section.key) ?? []).filter((district) => !isSection(district, index)).map((district) => districtRow(district, index, input));
        if (rows.length > 0) {
            sections.push({ key: section.key, title: section.shortTitle ?? section.title, rows });
        }
    }
    return {
        title: selection?.title,
        description: selection?.description,
        searchPlaceholder: selection?.searchPlaceholder,
        showCode: selection?.showCode ?? false,
        sections,
    };
}
